// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__1C-WD","notes":"Notes_notes__1h6IS"};